import { TrashIcon } from '@heroicons/react/24/solid';
import { observer } from 'mobx-react';
import { PEProgressBar } from '../../components/linear-progress';

type Props = {
  venues: any[];
  handleDelete: (locationId: string) => void;
  loading: boolean;
};
const SelectedVenueGeofences = ({ venues, handleDelete, loading }: Props) => {
  return (
    <div className="mt-4 block h-[35rem] overflow-auto w-full p-6 bg-gray-100 border border-gray-200 rounded-lg shadow">
      <p className="mb-4 font-normal text-xl hover:cursor-pointer text-primary-900">
        Venue Geofences: {venues.length ?? 0}
      </p>
      {loading && <PEProgressBar />}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
        {venues.map((v) => (
          <div className="w-full h-max bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="p-5 flex flex-row justify-between items-start">
              <div className="flex-1 min-w-0">
                <p className="mb-3 text-lg font-normal text-gray-700 dark:text-gray-400 truncate">
                  {v.name}
                </p>
              </div>
              <div className="hover:opacity-50 flex-shrink-0 ml-4">
                <TrashIcon
                  onClick={() => {
                    handleDelete(v.locationId);
                  }}
                  className="w-6 h-6"
                  color="red"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(SelectedVenueGeofences);
